import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../../../Components/CustomSnackbar';
import React, { useState, useEffect } from 'react';
import DialogStartCable from '../DialogConnectionComponents/DialogStartCable';
import DialogEndCable from '../DialogConnectionComponents/DialogEndCable';
import DialogConnectionComponentCable from '../DialogConnectionComponents/DialogConnectionComponentCable';
import { UpdateHighwayLine, UpdateHighwayLineContractNumber, UpdateHighwayLineLengthAct,
    UpdateHighwayLineCable, UpdateContractor, UpdateHighwayLineEngineer, UpdateHighwayLineCableNumber,
    UpdateRankCable,
    UpdateTypeCable} from '../../../UpdateData/UpdateCommunications';
import { CONST_HIGHWAY, CONST_SUBWAY } from '../../../Constants/ConstantsOptics';
import { loadingCableDataComponent, loadingCableTypeDataComponent, loadingRankCableDataComponent } from '../../../LoadingData/LoadingDataComponents';
import { UpdateLineActivityComponents, UpdateStatusComponents, UpdateStatusComponentsHighway } from '../../../UpdateData/UpdateStatusComponent';
import { loadingContractorDataComponent } from '../../../LoadingData/LoadingDataComponents';
import DialogCablePdfEditing from '../../DialogPdf/DialogCablePdfEditing';
import ModalDeleteComponentSpecifically from '../../../Modal/ModalDeleteComponentSpecifically';
import { CABLE, CABLE_FLAG } from '../../../Constants/ConstantsOptics';
import Select from 'react-select';


const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '16px',
    border: '1px solid #ffffff', 
    width: '230px',
    marginLeft: '-10px',
    marginRight: '-13px'
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};

const CableHighwayEditingDialog = ({ open, onClose, onClose2, content, user, changeLinkEditing, highwayRefresh, groupedCoordinatesWithColorTypeAndWidth,
  wellData,fobLocationData,couplingLocationData,ponBoxLocationData,pillarData, changeLinkEditingMarker, cantonCablaByIdRefresh }) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [textComment, setTextComment] = useState(content.description);
  const [textContractNumber, setTextContractNumber] = useState(content.contractNumber);
  const [textLengthAct, setTextLengthAct] = useState(content.lengthAct);
  const [statusChange, setStatusChange] = useState(false);
  const [statusChangeContractNumber, setStatusChangeContractNumber] = useState(false);
  const [statusChangeLengthAct, setStatusChangeLengthAct] = useState(false);
  const [openModalStart, setOpenModalStart] = useState(false);
  const [openModalEnd, setOpenModalEnd] = useState(false);
  const [openModalConnection, setOpenModalConnection] = useState(false);
  const [openModalConnectionDelete, setOpenModalConnectionDelete] = useState(false);
  const [cableData, setCableData] = useState([]);
  const [selectedFiberQuantity, setSelectedFiberQuantity] = useState(content.cableFiberQuantity);
  const [cableLineId, setCableLineId] = useState("");
  const [statusActive, setStatusActive] = useState(false); 
  const [contractorData, setContractorData] = useState([]);
  const [contractorId, setContractorId] = useState("");
  const [statusChangeEngineer, setStatusChangeEngineer] = useState(false);
  const [textEngineer, setTextEngineer] = useState(content.engineer);
  const [textCableNumber, setTextCableNumber] = useState(content.cableNumber);
  const [statusChangeCableNumber, setStatusChangeCableNumber] = useState(false);
  const [openModalPdf, setOpenModalPdf] = useState(false);
  const [rankCablaData, setRankCableData] = useState([]);
  const [rankCableId, setRankCableId] = useState("");
  const [typeCableData, setTypeCableData] = useState([]);
  const [typeCableId, setTypeCableId] = useState("");

  const openModalPdfFile = () => {
    setOpenModalPdf(true);
  }; 

  useEffect(() => {
    if (content.activity === 0) {
      setStatusActive(false);
    } else if (content.activity === 1) {
      setStatusActive(true);
    }
  }, [content.activity]); 

  const handleCloseDialogs = () => {
    onClose2();
    onClose();
  };

   useEffect(() => {
      const fetchData = async () => {
        try {
          const [cableData, contractorData, typeCableData, rankCablaData] = await Promise.all([
            loadingCableDataComponent(),
            loadingContractorDataComponent(),
            loadingCableTypeDataComponent(),
            loadingRankCableDataComponent(),
          ]);
          setCableData(cableData);
          setContractorData(contractorData);
          setTypeCableData(typeCableData);
          setRankCableData(rankCablaData);
  
        } catch (error) {
          // Обработка ошибок (если нужна)
          // console.error("Error in fetchData:", error);
        }
      };
    
      fetchData();
    }, []);


    const options = cableData.map(cable => ({
      value: `${cable.id},${cable.color},${cable.width},${cable.name},${cable.fiberQuantity}`,
      label: cable.name,
      group: cable.cableGroupId === 4 ? "Неизвестно" : cable.cableGroupId === 3 ? "Воздушка" : "Подземка",

    }));
    
    // Группировка опций
    const groupedOptions = [
      {
        label: "Воздушка",
        options: options.filter(option => option.group === "Воздушка"),
      },
      {
        label: "Подземка",
        options: options.filter(option => option.group === "Подземка"),
      },
      {
        label: "Неизвестно",
        options: options.filter(option => option.group === "Неизвестно"),
      },
    ];

  
  // const options = cableData.map(cable => ({
  //   value: `${cable.id},${cable.color},${cable.width},${cable.name},${cable.fiberQuantity}`,
  //   label: cable.name,
  //   group: cable.cableTypeId === 3 ? "Воздушка" : "Подземка",
  // }));

  // // Группировка опций
  // const groupedOptions = [
  //   {
  //     label: "Воздушка",
  //     options: options.filter(option => option.group === "Воздушка"),
  //   },
  //   {
  //     label: "Подземка",
  //     options: options.filter(option => option.group === "Подземка"),
  //   },
  // ];

  const handleChangeCableSelect = (selectedOption) => {
    if (!selectedOption) {
      // Если выбор сброшен
      setCableLineId("");
      setSelectedFiberQuantity(null);
      return;
    }
  
    const selectedCableValue = selectedOption.value; // Значение выбранной опции
  
    // Находим соответствующий объект из cableData
    const selectedCable2 = cableData.find(cable => 
      `${cable.id},${cable.color},${cable.width},${cable.name},${cable.fiberQuantity}` === selectedCableValue
    );
  
    if (selectedCable2) {
      setSelectedFiberQuantity(selectedCable2.fiberQuantity);
      setCableLineId(selectedCable2.id);
    }
  };

  

  const deleteLink = () => {
    UpdateStatusComponents(CABLE, content.id, showSnackbar, user, highwayRefresh, handleCloseDialogs, cantonCablaByIdRefresh );
  };
 
  const openModalStartComponents = () => {
    setOpenModalStart(true);
  };  

  const openModalEndComponents = () => {
    setOpenModalEnd(true);
  };  

  const openModalConnectionComponents = () => {
    setOpenModalConnection(true);
  }; 

  const openModalConnectionComponentsDelete = () => {
    setOpenModalConnectionDelete(true);
  }; 

  const handleDescriptionChange = (event) => {
    const newText = event.target.value;
    setTextComment(newText);

    if (newText !== content.comment) {
        setStatusChange(true);
    } else {
        setStatusChange(false);
    }
 };

 const handleContractNumberChange = (event) => {
  const newText = event.target.value;
  setTextContractNumber(newText);

  if (newText !== content.contractNumber) {
    setStatusChangeContractNumber(true);
  } else {
    setStatusChangeContractNumber(false);
  }
};

const handleLengthActChange = (event) => {
  const newText = event.target.value;
  setTextLengthAct(newText);

  if (newText !== content.lengthAct) {
    setStatusChangeLengthAct(true);
  } else {
    setStatusChangeLengthAct(false);
  }
};

 const handleClickEditLink = () => {
  changeLinkEditing(content.id, true, CONST_HIGHWAY);
};
  
  const updateHighwayLine = () => {
    if (statusChange) {
      UpdateHighwayLine(content.id, textComment, showSnackbar,content.authorId, highwayRefresh, cantonCablaByIdRefresh );
    } else {
      showSnackbar('Нет нужды в записи, текст без изменений!', 'snackbarOk');
    }
  };

  const updateHighwayLineContractNumber = () => {
    if (statusChangeContractNumber) {
      UpdateHighwayLineContractNumber(content.id, textContractNumber, showSnackbar,content.authorId, highwayRefresh, cantonCablaByIdRefresh );
    } else {
      showSnackbar('Нет нужды в записи, договор без изменений!', 'snackbarOk');
    }
  };

  const updateHighwayLineLengthAct = () => {
    if (statusChangeLengthAct) {
      UpdateHighwayLineLengthAct(content.id, textLengthAct, showSnackbar,content.authorId, highwayRefresh, cantonCablaByIdRefresh );
    } else {
      showSnackbar('Нет нужды в записи, длина без изменений!', 'snackbarOk');
    }
  };

const updateHighwayLineCable = () => {
  if (cableLineId === "") {
    showSnackbar('Нет нужды в записи, кабель без изменений!', 'snackbarOk');
  } else {
    UpdateHighwayLineCable(content.id, cableLineId, showSnackbar,content.authorId, highwayRefresh, cantonCablaByIdRefresh );
  }
};

 const updateRankCable = () => {
    if (rankCableId === "") {
      showSnackbar('Нет нужды в записи, тип без изменений!', 'snackbarOk');
    } else {
      UpdateRankCable(content.id, rankCableId, showSnackbar,content.authorId, highwayRefresh, cantonCablaByIdRefresh );
    } 
  };

   const updateTypeCable = () => {
      if (typeCableId === "") {
        showSnackbar('Нет нужды в записи, тип без изменений!', 'snackbarOk');
      } else {
        UpdateTypeCable(content.id, typeCableId, showSnackbar,content.authorId, highwayRefresh, cantonCablaByIdRefresh );
      } 
    };

const handleActiveCheckboxChange = () => {
  setStatusActive(!statusActive); 
 
  if(!statusActive){
    UpdateLineActivityComponents(content.id, 1, showSnackbar, highwayRefresh, content.authorId, cantonCablaByIdRefresh);
  }else{
    UpdateLineActivityComponents(content.id, 0, showSnackbar, highwayRefresh, content.authorId, cantonCablaByIdRefresh)
  }
  
};

const handleChangeContractorSelect = (event) => {
  const selectedContractor = event.target.value;
  if (selectedContractor === "") {
    setContractorId("");
  } else {
    const selectedContractor2 = contractorData.find(contractor => 
      `${contractor.id}` === selectedContractor
    );
    if (selectedContractor2) {
      setContractorId(selectedContractor2.id);  
    }
  }
};

const handleChangeTypeCableSelect = (event) => {
  const selectedType = event.target.value;

  if (selectedType === "") {
    setTypeCableId(""); 
  } else {
   
    const [selectedId] = selectedType.split(",");
    const selectedType2 = typeCableData.find(
      (type) => `${type.id}` === selectedId
    );

    if (selectedType2) {
      setTypeCableId(selectedType2.id); 
    }
  }
};

const handleChangeRankCableSelect = (event) => {
  const selectedRank = event.target.value;

  if (selectedRank === "") {
    setRankCableId(""); 
  } else {
   
    const [selectedId] = selectedRank.split(",");
    const selectedRank2 = rankCablaData.find(
      (rank) => `${rank.id}` === selectedId
    );

    if (selectedRank2) {
      setRankCableId(selectedRank2.id); 
    }
  }
};


const updateContractor = () => {
  if (contractorId === "") {
    showSnackbar('Нет нужды в записи, подрядчик без изменений!', 'snackbarOk');
  } else {
    UpdateContractor(content.id, contractorId, showSnackbar,content.authorId, highwayRefresh, cantonCablaByIdRefresh );
  } 
};

const handleEngineerChange = (event) => {
  const newText = event.target.value;
  setTextEngineer(newText);

  if (newText !== content.contractNumber) {
    setStatusChangeEngineer(true);
  } else {
    setStatusChangeEngineer(false);
  }
};

const updateHighwayLineEngineer = () => {
  if (statusChangeEngineer) {
    UpdateHighwayLineEngineer(content.id, textEngineer, showSnackbar,content.authorId, highwayRefresh, cantonCablaByIdRefresh );
  } else {
    showSnackbar('Нет нужды в записи, Engineer без изменений!', 'snackbarOk');
  }
};

const handleCableNumberChange = (event) => {
  const newText = event.target.value;
  setTextCableNumber(newText);

  if (newText !== content.contractNumber) {
    setStatusChangeCableNumber(true);
  } else {
    setStatusChangeCableNumber(false);
  }
};

const updateHighwayLineCableNumber = () => {
  if (statusChangeCableNumber) {
    UpdateHighwayLineCableNumber(content.id, textCableNumber, showSnackbar,content.authorId, highwayRefresh, cantonCablaByIdRefresh );
  } else {
    showSnackbar('Нет нужды в записи, номер кабеля без изменений!', 'snackbarOk');
  }
};

const handleClickEditLinkMarker = () => {
  changeLinkEditingMarker(content.id, true, CONST_HIGHWAY);
  onClose();
  onClose2();
};

    return (
  
    <Dialog open={open} className="dialogStyle">
    
      <DialogContent>
      <img src='./cable.png' width='30' height='30' style={{marginRight: "5px"}}/>
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset',textShadow: '2px 2px 4px #3d3d3d'}}>Редактирование кабеля</label>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe',textShadow: '2px 2px 4px #3d3d3d' }}>{content.id}</span></label>
       <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Территория: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.city}</span> </label>
      <hr className='horizontalLineDialog2'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Активна:</label>
      <input
         type="checkbox"
         checked={statusActive}
         onChange={handleActiveCheckboxChange}
         style={{ marginLeft: '10px' }}
       />
       


       <hr className='horizontalLineDialog2'/>

      <div style={{ display: 'flex', gap: '1rem', marginBottom: '-20px' }}>
       
       <label style={{ color: '#292929', fontWeight: 'bold'}}>Кабель: </label>

       <Select
           options={groupedOptions}
           onChange={(selectedOption) => handleChangeCableSelect(selectedOption)}
           placeholder={content.cableName || "Выберите кабель"}
           styles={customStyles}
           isClearable
        />

     
      <button onClick={updateHighwayLineCable} class='buttonIsSaveDialog2'>Сохранить</button>

      </div>


      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold' }}>Количество волокон: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{selectedFiberQuantity}</span></label>
      <br/>
      {/* <label style={{ color: '#292929', fontWeight: 'bold'}}>Тип: <span style={{ color: '#bebebe',fontWeight: 'normal' }}>{content.cableTypeType}</span></label> */}
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Тип:  </label>
        <select className="selectStyleDrawer" 

          onChange={(event) => {
            handleChangeTypeCableSelect(event);
          }} >
          <option value="">{content.cableTypeType}</option>
          {typeCableData.map(type => (
            <option key={type.id} value={type.id}>{type.type}</option>
          ))}
        </select>
        <button onClick={updateTypeCable} class='buttonIsSaveDialog2'>Сохранить</button>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Длина кабеля: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.lengthCable} м.</span></label>
      <hr className='horizontalLineDialog2'/>
      {/* <label style={{ color: '#292929', fontWeight: 'bold'}}>Принадлежность к узлам: <span style={{ color: '#bebebe',fontWeight: 'normal' }}>{content.rankCableName}</span></label> */}
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Принадлежность к узлам:  </label>
        <select className="selectStyleDrawer" 

          onChange={(event) => {
            handleChangeRankCableSelect(event);
          }} >
          <option value="">{content.rankCableName}</option>
          {rankCablaData
            .filter(rank => ![3, 5, 6, 7, 8, 9].includes(rank.id)) // Фильтрация ненужных ID
            .map(rank => (
              <option key={rank.id} value={rank.id}>{rank.name}</option>
            ))}
        </select>
        <button onClick={updateRankCable} class='buttonIsSaveDialog2'>Сохранить</button>
        <hr className='horizontalLineDialog2'/>

       <label style={{ color: '#292929', fontWeight: 'bold'}}>Подрядчик:  </label>
        <select className="selectStyleDrawer" 

          onChange={(event) => {
            handleChangeContractorSelect(event);
          }} >
          <option value="">{content.contractorName}</option>
          {contractorData.map(contractor => (
            <option key={contractor.id} value={contractor.id}>{contractor.name}</option>
          ))}
        </select>
        <button onClick={updateContractor} class='buttonIsSaveDialog2'>Сохранить</button>

        <hr className='horizontalLineDialog2'/>

        {content.cableTypeType === CONST_SUBWAY && (
          <>
          <label style={{ color: '#292929', fontWeight: 'bold' }}>Инженер: </label>

            <input
              className='textInputEditingModal'
              style={{width: '220px'}}
              value={textEngineer} 
              onChange={handleEngineerChange} 
            />
            <button onClick={updateHighwayLineEngineer} class='buttonIsSaveDialog2'>Сохранить</button>
            </>
          )}
      <hr className='horizontalLineDialog2'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Внес: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.authorId}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold' }}>Дата добавления: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{new Date(content.createDate).toISOString().slice(0, 19).replace("T", " ")}</span></label>
      <hr className='horizontalLineDialog2'/>

      {content.cableTypeType === CONST_SUBWAY && (
          <>
           <label style={{ color: '#292929', fontWeight: 'bold' }}>Номер договора: </label>
       
            <input
              className='textInputEditingModal'
              value={textContractNumber} 
              onChange={handleContractNumberChange} 
            />
            <button onClick={updateHighwayLineContractNumber} class='buttonIsSaveDialog2'>Сохранить</button>

            <hr className='horizontalLineDialog2'/>

            <label style={{ color: '#292929', fontWeight: 'bold' }}>Номер кабеля: </label>
       
            <input
              type='text'
              className='textInputEditingModal'
              value={textCableNumber} 
              onChange={handleCableNumberChange} 
            />
            <button onClick={updateHighwayLineCableNumber} class='buttonIsSaveDialog2'>Сохранить</button>

            <hr className='horizontalLineDialog2'/>

            <label style={{ color: '#292929', fontWeight: 'bold' }}>Длина (акт приема): </label>
       
            <input
              type='number'
              className='textInput2EditingModal'
              value={textLengthAct} 
              onChange={handleLengthActChange} 
            /> м.
            <button onClick={updateHighwayLineLengthAct} class='buttonIsSaveDialog2'>Сохранить</button>

            <hr className='horizontalLineDialog2'/>
            
          </>
        )}

      <label style={{ color: '#292929', fontWeight: 'bold' }}>Комментарий: </label>
       
        <textarea
          className='textAreaEditingModal'
          value={textComment} 
          onChange={handleDescriptionChange} 
        />
        <button onClick={updateHighwayLine} class='buttonIsSaveDialog2'>Сохранить</button>
     
     <hr className='horizontalLineDialog'/>
     <button  class='buttonIsStartEndDialog' onClick={openModalStartComponents}> Закрепить start кабеля</button>
     <img style={{marginLeft:'10px',marginRight: '10px'}} src='./vektor.png' alt='вектор' />
     <button  class='buttonIsStartEndDialog' onClick={openModalEndComponents}> Закрепить end кабеля</button>
    
     <br/>

      <button  class='buttonIsCoupFobDialog' onClick={openModalConnectionComponents}> Закрепить кабель</button>

      <hr className='horizontalLineDialog'/>
      <button class='buttonIsEditDialog' onClick={openModalConnectionComponentsDelete}>Удаление связей</button>
      <hr style={{ marginBottom: "0px", opacity: 0, border: 'none', backgroundColor: 'transparent' }} />

      <button  class='buttonIsEditDialog' onClick={handleClickEditLink}> Редактировать линк на карте</button>
      <hr style={{ marginBottom: "0px", opacity: 0, border: 'none', backgroundColor: 'transparent' }} />

      <button  class='buttonIsEditDialog' onClick={handleClickEditLinkMarker}> Пометить проблемное место
          <img 
        src="./problem.png" 
        alt="Проблема" 
        width="20" 
        height="20" 
        style={{ marginLeft: "8px" }}
      />
      </button>
      <hr style={{ marginBottom: "0px", opacity: 0, border: 'none', backgroundColor: 'transparent' }} />
      {content.cableTypeType === CONST_SUBWAY && (
        <>
          <button  class='buttonIsEditDialog' onClick={openModalPdfFile}> Редактирование файлов</button>
        </>
      )}

    <hr className='horizontalLineDialog'/>

    <button 
      className="buttonIsDeleteModal" 
      onClick={deleteLink} 
      style={{ fontSize: "14px", width: "60px", padding: "2px",textShadow: '2px 2px 4px #3d3d3d' }}
    >
      Удалить
    </button>

    <span 
      style={{
        marginLeft: "5px",
        fontSize: "12px",
        color: "#bebebe",
        textShadow: "0 0 5px rgba(0, 0, 0, 0.8)",  
      }}
    >
    Восстановление доступно в течение 24 часов
  </span>

    

      </DialogContent>

      <DialogActions>
        <Button onClick={handleCloseDialogs} class='buttonIsHideDrawer23'>
          Закрыть
        </Button>
      </DialogActions>

       {/* Snackbar */}
       <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />
        <DialogStartCable
        id={content.id}
        open={openModalStart}
        onClose={() => setOpenModalStart(false)}
        user={user}
      />

      <DialogEndCable
        id={content.id}
        open={openModalEnd}
        onClose={() => setOpenModalEnd(false)}
        user={user}
      />

      <DialogConnectionComponentCable
        id={content.id}
        open={openModalConnection}
        onClose={() => setOpenModalConnection(false)}
        user={user}
    />

    {/* Modal PDF*/}
   <DialogCablePdfEditing
          open={openModalPdf}
          onClose={() => setOpenModalPdf(false)}
          id={content.id}
          user={content.authorId}     
      />  
      
      <ModalDeleteComponentSpecifically
          open={openModalConnectionDelete}
          onClose={() => setOpenModalConnectionDelete(false)}
          id={content.id}
          type={CABLE}
          flag={CABLE_FLAG}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
          wellData={wellData}
          fobLocationData={fobLocationData}
          couplingLocationData={couplingLocationData}
          ponBoxLocationData={ponBoxLocationData}
          pillarData={pillarData}
        />
    </Dialog>
  );
  
}

export default CableHighwayEditingDialog;